import React, { Component } from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import '@fortawesome/fontawesome-free/css/all.css';
import JobTable from './JobTable';


export default class Welcome extends React.Component {

  render() {

    const divStyle = {
      backgroundImage: 'url(img/img_04.jpg)',
      backgroundSize: '100%',
      backgroundPostion: '100px'
      };
      
    return (
     <div>
     <div className="animated fadeIn websitepages">
      <div className="overlay"></div>
        <div className="parallaximage aboutimg text-center  whitetext bgtoppostion  " style={divStyle}>
          <div className="container">
            <div className="col-lg-16 col-md-12 col-sm-12 headerareas overlaytext">
              <h1 className="sans_fontheader font-weight-bold">Online Job Sites</h1>
              
              <div className="text-center"></div>
              <div className="clearfixblock"></div>
            </div>
            <div className="clearfixblock"></div>
          </div>
          <div className="clearfixblock"></div>
        </div>
        <div className="pb-5 overlaybackground">
          <div className="container ptb-40">
            <div className="col-md-16 pb-5 text-center ">
            </div>
            <div className="col-md-16 pagecontents text-center ">
              
           <JobTable />
            </div>
          </div>
          
          <div className="clearfixblock"></div>
        </div>
      </div>
       
   </div>
    );
  }
}
